import { getFavorite, removeFavorite } from 'Api/favoriteApi'
import { apiErrorList } from 'Services/restAdviser'

const state = {
  filter: '',
  sort: 0,

  requesting: {
    list: false,
    delete: false,
  },

  pagination: {
    current: 1,
    size: 1
  },

  companyList: [],
  errorList: [],
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },
  request_success(state, type) {
    state.requesting[type] = false
  },
  request_failure(state, { type, errorList }) {
    state.requesting[type] = false
    state.errorList = errorList
  },

  set_pagination(state, pagination) {
    state.pagination = Object.assign(state.pagination, pagination)
  },
  set_filter(state, filter) {
    state.filter = filter
  },
  set_sort(state, sort) {
    state.sort = sort
  },
  set_company_list(state, companyList) {
    state.companyList = companyList
  },
}

const actions = {
  async fetchFavorites({ commit, state }, list = []) {
    commit('request_start', 'list')

    try {
      const { data } = await getFavorite(
        state.pagination.current,
        state.filter
      )
      console.log('fetchFavorites', data)
      const companyList = [
        ...list,
        ...data.items
      ]

      const pagination = {
        current: data.page,
        size: data.pageSize,
      }

      commit('request_success', 'list')
      commit('set_company_list', companyList)
      commit('set_pagination', pagination)

      return data
    } catch (err) {
      commit('request_failure', {
        type: 'list',
        errorList: apiErrorList(err),
      })

      throw err
    }
  },

  async removeFavorite({ commit }, companyId) {
    commit('request_start', 'delete')

    try {
      const { data } = await removeFavorite(companyId)

      commit('request_success', 'delete')

      return data
    } catch (err) {
      commit('request_failure', {
        type: 'delete',
        errorList: apiErrorList(err),
      })

      throw err
    }
  },

  updateFilter({ commit }, filter) {
    commit('set_filter', filter)
  },
}

export default {
  namespaced: true,

  state,
  mutations,
  actions,
}